exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./fonts.css"), "");

// Module
exports.push([module.id, ".align-text-right {\n    text-align: right;\n}\n\n.align-text-center {\n    text-align: center;\n}\n\n.seperator {\n    padding: 0px 10px;\n}\n\n.margin-top-100px {\n    margin-top: 100px;\n}\n\n.hide {\n    display: none;\n}\n\n.float-right {\n    float: right;\n}\n\n.margin-left-50px {\n    margin-left: 50px;\n}\n\n.container {\n    padding: 0px;\n}", ""]);

